<template>
  <div>
    <div v-if="!isMobile" class="flex flex-col justify-between w-full">
      <div class="flex flex-row max-w-[1300px] w-full mx-auto">
        <component :is="currentTab === 'bilpop' ? 'h1' : 'div'" class="flex -ml-6 flex-col relative items-center justify-center">
          <OButton
            pure
            class="btn--tab font-bold px-6 py-4 relative"
            :class="{ 'text-[#F0E2FF] font-extrabold': currentTab === 'bilpop', 'text-[#DDE3FF] font-medium': currentTab === 'emojile' }"
            :href="tabUrl('bilpop')"
          >
            Bilpop
          </OButton>
          <OIcon v-if="currentTab === 'bilpop'" class="absolute -bottom-0.5 text-[#F7F8FB]" icon="union" />
        </component>
        <component :is="currentTab === 'emojile' ? 'h1' : 'div'" class="flex flex-col relative items-center justify-center">
          <OButton
            pure
            class="btn--tab font-bold px-6 py-4 relative"
            :class="{ 'text-[#F0E2FF] font-medium': currentTab === 'bilpop', 'text-[#DDE3FF] font-extrabold': currentTab === 'emojile' }"
            :href="tabUrl('emojile')"
          >
            Emojile
          </OButton>
          <OIcon v-if="currentTab === 'emojile'" class="absolute -bottom-0.5 text-[#F7F8FB]" icon="union" />
        </component>
      </div>
    </div>

    <div
      v-else
      class="h-[75px] flex flex-col"
      :class="{ bilpopHeader: currentTab === 'bilpop', emojileMobileHeader: currentTab === 'emojile' }"
    >
      <div class="flex flex-row ml-7 mt-5">
        <div class="flex flex-col relative items-center justify-center">
          <OButton
            pure
            class="btn--tab font-bold px-6 py-4 relative"
            :class="{ 'text-[#F0E2FF] font-extrabold': currentTab === 'bilpop', 'text-[#DDE3FF] font-medium': currentTab === 'emojile' }"
            :href="tabUrl('bilpop')"
          >
            Bilpop
          </OButton>
          <OIcon v-if="currentTab === 'bilpop'" class="absolute -bottom-0.5 text-[#F7F8FB]" icon="union" />
        </div>
        <div class="flex flex-col relative items-center justify-center">
          <OButton
            pure
            class="btn--tab font-bold px-6 py-4 relative"
            :class="{ 'text-[#F0E2FF] font-medium': currentTab === 'bilpop', 'text-[#DDE3FF] font-extrabold': currentTab === 'emojile' }"
            :href="tabUrl('emojile')"
          >
            Emojile
          </OButton>
          <OIcon v-if="currentTab === 'emojile'" class="absolute -bottom-0.5 text-[#F7F8FB]" icon="union" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, useRoute } from '@nuxtjs/composition-api';
import { OButton, OIcon } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { IS_ONEDIO, GAMES_PATH } from '~/constants/config';

export default defineComponent({
  props: {
    currentTab: {
      required: true,
      type: String,
    },
  },
  components: { OButton, OIcon },
  setup() {
    const { isMobile } = useDevice();
    const route = useRoute();
    const isWebview = route.value?.path.includes('/mobile/oyun/');
    const slug = route.value?.path.split('/')[isWebview ? 3 : 2];
    const tabUrl = (game) => `${isWebview ? '/mobile' : ''}/${GAMES_PATH}/${slug}/${game}`;

    return { isMobile, IS_ONEDIO, tabUrl };
  },
});
</script>

<style scoped lang="scss">
.emojileMobileHeader {
  background: linear-gradient(166deg, #00084d -6.27%, #2c4389 100%);
}
</style>
